import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { fmt } from "../lib/api";
import MaterialSearch, { specLine } from "../components/MaterialSearch";
import PrintDialog from "../components/PrintDialog";

export default function CekStock() {
  const [sp] = useSearchParams();
  const [g, setG] = useState(null);
  const [print, setPrint] = useState(null);
  return (
    <div className="card" data-testid="cekstock-page">
      <h3>CEK STOCK / 查询库存</h3>
      <MaterialSearch onSelect={setG} testid="cek-search" initialQuery={sp.get("barcode") || ""} />
      {g && (
        <div className="area-panel" data-testid="cek-result">
          <div className="card-head"><div><b className="code-big">{g.material_code}</b><div className="muted">{g.kategori} • {specLine(g)}</div></div>
            <div className="stock-total" data-testid="cek-total">{fmt(g.total_qty)} {g.satuan}<small>{fmt((g.total_qty * g.kg_per_unit) / 1000)} Ton • {fmt(g.kg_per_unit)} kg/unit</small></div></div>
          <div className="table-wrap"><table className="data-table"><thead><tr><th>Area</th><th>Barcode ID</th><th>Grade</th><th>Tebal</th><th>Supplier</th><th>Qty</th><th>Menunggu Verif.</th><th>Aksi</th></tr></thead><tbody>
            {g.rows.map((r) => <tr key={r.barcode_id + r.area}><td><b>{r.area}</b></td><td><Link to={`/scan/${r.barcode_id}`} data-testid={`cek-link-${r.barcode_id}`}>{r.barcode_id}</Link></td><td>{r.grade}</td><td>{r.tebal}</td><td>{r.supplier}</td><td><b>{fmt(r.qty)}</b></td><td>{fmt(r.reserved)}</td>
              <td><button className="btn-mini" onClick={() => setPrint({ barcodeId: r.barcode_id, area: r.area, stock: r.qty, satuan: g.satuan })} data-testid={`cek-print-${r.barcode_id}-${r.area}`}>Cetak Label</button></td></tr>)}
          </tbody></table></div>
        </div>
      )}
      {print && <PrintDialog {...print} onClose={() => setPrint(null)} />}
    </div>
  );
}
